import '@chatui/core/dist/index.css';
import React, { useContext, useEffect, useRef, useState } from 'react';
import UnlimitedComponentContainer from './unlimited-component-container';
import { websocketConnection } from '../../../../http/common/websocket';
import { AppContext } from '../../../../contexts/AppContext';

const GenerativePageContainer: React.FC<any> = () => {
  const { chatEvent, menuCollapsed } = useContext(AppContext);
  const [components, setComponents] = useState<any>([]);
  const [containerWidth, setContainerWidth] = useState<any>(1600);
  const ref: any = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (ref && ref.current) {
        setContainerWidth(ref.current.clientWidth);
      }
    }, 210);
  }, [menuCollapsed]);

  useEffect(() => {
    if (!chatEvent) {
      return;
    }
    if (chatEvent.eventType === 'CHAT_MESSAGE_UPDATED' && chatEvent.data.role === 'user') {
      websocketConnection('test-page', 'test-content', chatEvent.data.message, (layouts) => {
        setComponents(layouts);
      });
    }
  }, [chatEvent]);

  return (
    <div ref={ref} className="generative-page-container">
      {components && components.length > 0 ? <UnlimitedComponentContainer width={containerWidth} components={components} /> : <></>}
    </div>
  );
};

export default GenerativePageContainer;
